<template>
  <div class="LD_wrapper">
    <div class="title">강좌 설명</div>
    <div class="buttons">
      <b-button variant="success">수강신청</b-button>
      <b-button variant="danger">취소</b-button>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
.LD_wrapper {
  .title {
    font-size: 2em;
  }
}
</style>